// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document-personal{padding-bottom:56px}.document-personal h2{max-width:900px;text-align:center;margin-left:auto;margin-right:auto}.document-personal__content{padding:16px;background-color:var(--13i3hbf);border:var(--13558d5);border-radius:var(--15ty9t8)}@media only screen and (min-width:992px){.document-personal__content{padding:26px 32px 12px}}", ""]);
// Exports
module.exports = exports;
